var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V16L18.5 18.5",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33773 10.8705L7.58774 10.8743C7.58981 11.2856 7.92269 11.6184 8.33396 11.6205L8.33773 10.8705ZM10.8795 11.6333C11.2937 11.6354 11.6312 11.3013 11.6333 10.8871C11.6353 10.4729 11.3013 10.1354 10.887 10.1333L10.8795 11.6333ZM9.07493 8.32121C9.07285 7.907 8.73538 7.57291 8.32117 7.57499C7.90696 7.57707 7.57287 7.91454 7.57495 8.32875L9.07493 8.32121ZM7.82658 14.7849C7.88283 14.3745 7.59575 13.9963 7.18537 13.94C6.775 13.8838 6.39672 14.1708 6.34047 14.5812L7.82658 14.7849ZM22.8622 9.13778C19.042 5.31759 12.8687 5.2789 9.07378 9.07382L10.1344 10.1345C13.3335 6.93537 18.5571 6.95396 21.8016 10.1984L22.8622 9.13778ZM9.13774 22.8622C12.9579 26.6824 19.1313 26.7211 22.9262 22.9262L21.8655 21.8655C18.6664 25.0646 13.4429 25.0461 10.1984 21.8016L9.13774 22.8622ZM22.9262 22.9262C26.7211 19.1313 26.6824 12.958 22.8622 9.13778L21.8016 10.1984C25.0461 13.4429 25.0646 18.6664 21.8655 21.8655L22.9262 22.9262ZM9.07378 9.07382L7.8074 10.3402L8.86806 11.4009L10.1344 10.1345L9.07378 9.07382ZM8.33396 11.6205L10.8795 11.6333L10.887 10.1333L8.3415 10.1205L8.33396 11.6205ZM9.08772 10.8668L9.07493 8.32121L7.57495 8.32875L7.58774 10.8743L9.08772 10.8668ZM6.34047 14.5812C5.93904 17.5099 6.87389 20.5984 9.13774 22.8622L10.1984 21.8016C8.27782 19.881 7.4866 17.2652 7.82658 14.7849L6.34047 14.5812Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/Edit icon.3d4710d38c366d417dbae80ea1f40b32.svg";
export { ForwardRef as ReactComponent };